import { WEIGHT_UNIT_TYPES_OPTIONs_WITH_GRAM } from "../../../../../config/optionsConstants";
import { PackagingMaterialRecord } from "../types/packagingDetail.types";
import { MaterialFormValues } from "../types/packagingMaterial.types";

export const toFormValues = (record: PackagingMaterialRecord): MaterialFormValues => ({
  name: record.name,
  material: record.material,
  weight: record.weight,
  weightUnit: record.weightUnit,
  cost: record.cost
});

export const weightUnitLabel = (value: string | number | undefined) =>
  WEIGHT_UNIT_TYPES_OPTIONs_WITH_GRAM.find(o => String(o.value) === String(value))?.text ?? "";

/** Format weight preserving sub-0.1 kg packaging mass (e.g. 0.5 g → 0.0005 kg). */
export const formatWeightNumber = (value: number): string => {
  const abs = Math.abs(value);
  const hasSubTenthPrecision =
    Number.isFinite(value) && Math.abs(abs * 10 - Math.round(abs * 10)) > 1e-9;

  if (hasSubTenthPrecision) {
    return parseFloat(value.toFixed(4)).toString();
  }

  return value.toFixed(1);
};

export const formatWeightValue = (value: number | string, unit?: string) => {
  if (value === null || value === undefined || value === "" || value === 0) {
    return "—";
  }

  const numericValue = typeof value === "number" ? value : Number(value);
  const formatted = Number.isFinite(numericValue)
    ? formatWeightNumber(numericValue)
    : String(value);

  return unit ? `${formatted} ${unit}` : formatted;
};
